// @ts-nocheck — W2.1 in-place migration: TS strict aplicado em waves subsequentes
import BingImagerySet from "./geocloud2/lov/BingImagerySet.js";
import GoogleImagerySet from "./geocloud2/lov/GoogleImagerySet.js";
import HereImagerySet from "./geocloud2/lov/HereImagerySet.js";

/**
 * @enum {string}
 */
export default {
  '[BING_ROADMAP]': BingImagerySet.ROADMAP,
  '[BING_SATELLITE]': BingImagerySet.SATELLITE,
  '[BING_HYBRID]': BingImagerySet.HYBRID,

  '[GOOGLE_ROADMAP]': GoogleImagerySet.ROADMAP,
  '[GOOGLE_SATELLITE]': GoogleImagerySet.SATELLITE,
  '[GOOGLE_HYBRID]': GoogleImagerySet.HYBRID,
  '[GOOGLE_TERRAIN]': GoogleImagerySet.TERRAIN,
  '[GOOGLE_STREETVIEW]': GoogleImagerySet.STREETVIEW,

  '[HERE_ROADMAP]': HereImagerySet.ROADMAP,
  '[HERE_SATELLITE]': HereImagerySet.SATELLITE,
  '[HERE_HYBRID]': HereImagerySet.HYBRID,
  '[HERE_TERRAIN]': HereImagerySet.TERRAIN,

};